import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const SuppressionList = () => import('./SuppressionList.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      // props as a function so the Ongoing tab shows its own header instead of
      // inheriting the one-off title from this shared parent route.
      props: route => ({
        headerTitle:
          route.name === 'ongoing_campaigns'
            ? 'CAMPAIGN.ONGOING.HEADER'
            : 'CAMPAIGN.ONE_OFF.HEADER',
        icon: 'sound-source',
      }),
      children: [
        {
          path: '',
          redirect: 'one_off',
        },
        {
          path: 'one_off',
          name: 'one_off',
          meta: {
            permissions: ['administrator', 'supervisor'],
          },
          component: Index,
        },
        {
          path: 'ongoing',
          name: 'ongoing_campaigns',
          meta: {
            permissions: ['administrator', 'supervisor'],
          },
          component: Index,
        },
        {
          path: 'suppressions',
          name: 'campaigns_suppressions',
          meta: {
            permissions: ['administrator'],
          },
          component: SuppressionList,
        },
      ],
    },
  ],
};
